<template>
  <v-container>
    <h3>アラーム出力設定</h3>

    <div class="mt-8 mb-5">
      <v-row>
        <v-col :cols="$vuetify.display.mobile ? 12 : 4" class="d-flex align-center">
          <v-label>チャンネル選択</v-label>
        </v-col>
        <v-col :cols="$vuetify.display.mobile ? 12 : 8">
          <v-select density="compact" hide-details="true"
            v-model:model-value="outputChannelKey" :items="outputChannels" :readonly="isSendingGetAlarmCommand"></v-select>
        </v-col>
      </v-row>

      <v-divider class="my-7"></v-divider>

      <div class="text-center" v-if="isSendingGetAlarmCommand">
        <v-progress-circular indeterminate></v-progress-circular>
      </div>

      <v-alert variant="tonal" color="error" v-if="isGetAlarmCommandSuccess === false">
        モジュールとの通信に失敗しました。モジュールの電源状態や、インターネット接続をご確認ください
      </v-alert>

      <v-alert variant="tonal" type="success" v-model="isShowDeleteSuccessMessage" closable>
        選択されたチャンネルのアラーム出力設定を解除しました
      </v-alert>

      <v-row class="mt-1" v-if="isGetAlarmCommandSuccess">
        <v-col :cols="$vuetify.display.mobile ? 12 : 4" class="d-flex align-center">
          <v-label class="text-subtitle-1">入力チャンネル</v-label>
        </v-col>
        <v-col :cols="$vuetify.display.mobile ? 12 : 8">
          <v-select density="compact" hide-details="true"
            v-model:model-value="inputChannelKey" :items="inputChannels"></v-select>
        </v-col>

        <v-col cols="12" v-if="inputChannelKey !== ''">
          <v-row class="mt-1">

            <v-col cols="12">
              <v-row>
                <v-col cols="12" v-if="!inputChannelKey.startsWith('d') || payload.threshold.lower == null">
                  <v-label class="text-subtitle-1">上限値設定</v-label>
                </v-col>

                <v-col cols="12" v-for="(upperThreshold, index) in payload.threshold.upper" v-bind:key="upperThreshold.val">
                  <v-card variant="outlined" elevation="1">
                    <v-card-item>
                      <v-card-title class="text-subtitle-2 font-weight-bold">
                        {{ convertToPhysicalValue(upperThreshold.val) }}&nbsp;{{ inputUnit }}&nbsp;以上
                      </v-card-title>
                    </v-card-item>
                    <v-card-text>
                      <v-row>
                        <v-col :cols="$vuetify.display.mobile ? 5 : 1" class="d-flex align-center">
                          <v-label class="text-subtitle-2">出力</v-label>
                        </v-col>
                        <v-col :cols="$vuetify.display.mobile ? 7 : 3">
                          <p class="text-subtitle-1">
                            {{ (upperThreshold.action.val === 1) ? 'ON' : 'OFF' }}
                          </p>
                        </v-col>
                        <v-col :cols="$vuetify.display.mobile ? 5 : 2" class="d-flex align-center" v-if="upperThreshold.action.duration">
                          <v-label class="text-subtitle-2">出力継続時間</v-label>
                        </v-col>
                        <v-col :cols="$vuetify.display.mobile ? 7 : 6" v-if="upperThreshold.action.duration">
                          <p class="text-subtitle-1">
                            {{ (upperThreshold.action.duration % 10 === 0) ?
                              ((upperThreshold.action.duration / 10).toString() + ' 秒') : (upperThreshold.action.duration.toString() + '00 ミリ秒') }}
                          </p>
                        </v-col>
                      </v-row>
                    </v-card-text>
                    <v-card-actions class="d-flex justify-end">
                      <v-btn icon="mdi-delete" size="small" color="error" v-on:click="deleteUpperThreshold(index);"></v-btn>
                    </v-card-actions>
                  </v-card>
                </v-col>

                <v-col :cols="$vuetify.display.mobile ? 12 : 10" class="d-flex justify-center"
                  v-if="(inputChannelKey.startsWith('d')) ?
                    (payload.threshold.upper == null && payload.threshold.lower == null) : (payload.threshold.upper == null || payload.threshold.upper.length < 5)">
                  <v-btn variant="outlined" prepend-icon="mdi-plus"
                    v-on:click="thresholdType = 'upper'; isShowInputActionDialog = true;">追加する</v-btn>
                </v-col>
              </v-row>
            </v-col>

            <v-col cols="12" v-if="payload.threshold.lower || payload.threshold.upper">
              <v-row>
                <v-col cols="12">
                  <v-label class="text-subtitle-1">正常値復帰時</v-label>
                </v-col>

                <v-col cols="12" v-if="payload.threshold.recovered">
                  <v-card variant="outlined" elevation="1">
                    <v-card-text>
                      <v-row>
                        <v-col :cols="$vuetify.display.mobile ? 5 : 1" class="d-flex align-center">
                          <v-label class="text-subtitle-2">出力</v-label>
                        </v-col>
                        <v-col :cols="$vuetify.display.mobile ? 7 : 3">
                          <p class="text-subtitle-1">
                            {{ (payload.threshold.recovered.action.val === 1) ? 'ON' : 'OFF' }}
                          </p>
                        </v-col>
                        <v-col :cols="$vuetify.display.mobile ? 5 : 2" class="d-flex align-center" v-if="payload.threshold.recovered.action.duration">
                          <v-label class="text-subtitle-2">出力継続時間</v-label>
                        </v-col>
                        <v-col :cols="$vuetify.display.mobile ? 7 : 6" v-if="payload.threshold.recovered.action.duration">
                          <p class="text-subtitle-1">
                            {{ (payload.threshold.recovered.action.duration % 10 === 0) ?
                              ((payload.threshold.recovered.action.duration / 10).toString() + ' 秒') : (payload.threshold.recovered.action.duration.toString() + '00 ミリ秒') }}
                          </p>
                        </v-col>
                      </v-row>
                    </v-card-text>
                    <v-card-actions class="d-flex justify-end">
                      <v-btn icon="mdi-delete" size="small" color="error" v-on:click="delete payload.threshold.recovered;"></v-btn>
                    </v-card-actions>
                  </v-card>
                </v-col>

                <v-col :cols="$vuetify.display.mobile ? 12 : 10" class="d-flex justify-center" v-else>
                  <v-btn variant="outlined" prepend-icon="mdi-plus"
                    v-on:click="thresholdType = 'recovered'; isShowInputActionDialog = true;">動作設定</v-btn>
                </v-col>
              </v-row>
            </v-col>

            <v-col cols="12">
              <v-row>
                <v-col cols="12" v-if="!inputChannelKey.startsWith('d') || payload.threshold.upper == null">
                  <v-label class="text-subtitle-1">下限値設定</v-label>
                </v-col>

                <v-col cols="12" v-for="(lowerThreshold, index) in payload.threshold.lower" v-bind:key="lowerThreshold.val">
                  <v-card variant="outlined" elevation="1">
                    <v-card-item>
                      <v-card-title class="text-subtitle-2 font-weight-bold">
                        {{ convertToPhysicalValue(lowerThreshold.val) }}&nbsp;{{ inputUnit }}&nbsp;以下
                      </v-card-title>
                    </v-card-item>
                    <v-card-text>
                      <v-row>
                        <v-col :cols="$vuetify.display.mobile ? 5 : 1" class="d-flex align-center">
                          <v-label class="text-subtitle-2">出力</v-label>
                        </v-col>
                        <v-col :cols="$vuetify.display.mobile ? 7 : 3">
                          <p class="text-subtitle-1">
                            {{ (lowerThreshold.action.val === 1) ? 'ON' : 'OFF' }}
                          </p>
                        </v-col>
                        <v-col :cols="$vuetify.display.mobile ? 5 : 2" class="d-flex align-center" v-if="lowerThreshold.action.duration">
                          <v-label class="text-subtitle-2">出力継続時間</v-label>
                        </v-col>
                        <v-col :cols="$vuetify.display.mobile ? 7 : 6" v-if="lowerThreshold.action.duration">
                          <p class="text-subtitle-1">
                            {{ (lowerThreshold.action.duration % 10 === 0) ?
                              ((lowerThreshold.action.duration / 10).toString() + ' 秒') : (lowerThreshold.action.duration.toString() + '00 ミリ秒') }}
                          </p>
                        </v-col>
                      </v-row>
                    </v-card-text>
                    <v-card-actions class="d-flex justify-end">
                      <v-btn icon="mdi-delete" size="small" color="error" v-on:click="deleteLowerThreshold(index);"></v-btn>
                    </v-card-actions>
                  </v-card>
                </v-col>

                <v-col :cols="$vuetify.display.mobile ? 12 : 10" class="d-flex justify-center"
                  v-if="(inputChannelKey.startsWith('d')) ?
                    (payload.threshold.lower == null && payload.threshold.upper == null) : (payload.threshold.lower == null || payload.threshold.lower.length < 5)">
                  <v-btn variant="outlined" prepend-icon="mdi-plus"
                    v-on:click="thresholdType = 'lower'; isShowInputActionDialog = true;">追加する</v-btn>
                </v-col>
              </v-row>
            </v-col>

            <v-col cols="12" class="mt-6">
              <v-form @submit.prevent ref="mainForm">
                <v-row>
                  <v-col :cols="$vuetify.display.mobile ? 12 : 4" class="d-flex align-center">
                    <v-label class="text-subtitle-1">判定無効化時間（分）</v-label>
                  </v-col>
                  <v-col :cols="$vuetify.display.mobile ? 12 : 4">
                    <v-text-field density="compact"
                      :rules="[ v => (v && Number.isInteger(Number(v)) && 0 <= Number(v) && Number(v) <= 1440) || '必須、数値（0 ～ 1440）' ]"
                      persistent-hint hint="必須、数値（0 ～ 1440）"
                      v-model="disabledMinutes"></v-text-field>
                  </v-col>
                </v-row>
              </v-form>
            </v-col>

            <v-col cols="12" class="mt-1">
              <v-alert variant="tonal" type="error" v-model="isShowThresholdEmptyMessage" closable>
                1つ以上の閾値を設定してください
              </v-alert>

              <v-alert variant="tonal" type="success" v-model="isShowSetSuccessMessage" closable>
                設定が完了しました
              </v-alert>
            </v-col>

            <v-col cols="12" class="mt-5 d-flex justify-space-between">
              <v-btn variant="outlined" color="error" v-on:click="isShowDeleteAlarmConfirmDialog = true;"
                v-if="!$vuetify.display.mobile" v-bind:class="{ 'v-hidden': !hasAlarmThresholds }">
                アラーム出力設定を解除
              </v-btn>

              <v-btn elevation="0" color="primary" v-on:click="showSetAlarmConfirmDialog">
                設定する
              </v-btn>
            </v-col>

            <v-col cols="12" v-if="$vuetify.display.mobile && hasAlarmThresholds">
              <v-btn variant="outlined" color="error" v-on:click="isShowDeleteAlarmConfirmDialog = true;">
                アラーム出力設定を解除
              </v-btn>
            </v-col>
          </v-row>
        </v-col>
      </v-row>
    </div>
  </v-container>

  <v-dialog persistent max-width="800" v-model="isShowInputActionDialog">
    <v-card>
      <v-card-item>
        <v-card-title>
          {{ thresholdType === 'recovered' ? '正常値復帰時' : thresholdType === 'upper' ? '上限値設定' : '下限値設定' }}
        </v-card-title>
      </v-card-item>
      <v-card-text class="py-5">
        <v-form @submit.prevent ref="dialogForm">
          <v-row>
            <v-col cols="12" v-if="thresholdType !== 'recovered'">
              <v-label>
                閾値{{ (inputUnit === '') ? '' : '（' + inputUnit + '）' }}
              </v-label>
            </v-col>
            <v-col cols="7" v-if="thresholdType !== 'recovered'">
              <v-text-field density="compact" hide-details
                :rules="[ v => (!!v) || '必須、数値', v => (v && !isNaN(Number(v))) || '必須、数値' ]"
                v-model="thresholdVal" :readonly="inputChannelKey.startsWith('d')"></v-text-field>
            </v-col>
            <v-col cols="5" class="d-flex align-center" v-if="thresholdType !== 'recovered'">
              <p>
                <span class="font-weight-bold text-decoration-underline">
                  {{ thresholdType === 'upper' ? '以上' : '以下' }}
                </span>&nbsp;のとき
              </p>
            </v-col>
            <v-col cols="12">
              <v-label>出力</v-label>
            </v-col>
            <v-col cols="12">
              <v-btn-toggle variant="outlined" divided class="d-flex"
                mandatory v-model="outputVal">
                <v-btn color="primary" class="flex-fill" value="ON">ON</v-btn>
                <v-btn class="flex-fill" value="OFF">OFF</v-btn>
              </v-btn-toggle>
            </v-col>
            <v-col cols="12">
              <v-switch inset color="primary" hide-details v-model="hasDuration">
                <template v-slot:label>出力継続時間を指定する</template>
              </v-switch>
            </v-col>
            <v-col cols="12" v-if="hasDuration">
              <v-row no-gutters>
                <v-col cols="7" class="pe-1">
                  <v-text-field density="compact"
                    :suffix="(durationUnit === 'mSec') ? '00' : ''"
                    :rules="[ v => (v && Number.isInteger(Number(v)) && 1 <= Number(v) && Number(v) <= 6000) || '数値（1 ～ 6000）' ]"
                    persistent-hint hint="数値（1 ～ 6000）"
                    v-model="duration"></v-text-field>
                </v-col>
                <v-col cols="5">
                  <v-select density="compact" v-model:model-value="durationUnit"
                    :items="[{ title: 'ミリ秒', value: 'mSec' }, { title: '秒', value: 'sec' }]"></v-select>
                </v-col>
              </v-row>
            </v-col>

            <v-col cols="12" v-if="isShowThresholdConflictMessage">
              <v-alert variant="tonal" color="error" v-model="isShowThresholdConflictMessage" closable>
                同一の閾値設定が存在します
              </v-alert>
            </v-col>
          </v-row>
        </v-form>
      </v-card-text>
      <v-card-actions class="pa-3 justify-space-between">
        <v-btn v-on:click="isShowInputActionDialog = false;">キャンセル</v-btn>
        <v-btn color="primary" v-on:click="updatePayload">確定</v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>

  <v-dialog persistent max-width="400" v-model="isShowSetAlarmConfirmDialog">
    <v-card>
      <v-card-text>
        アラーム出力設定を行います。よろしいですか？
      </v-card-text>
      <v-card-actions class="d-flex justify-end">
          <v-btn v-on:click="isShowSetAlarmConfirmDialog = false;" v-if="!isSendingSetAlarmCommand">
            キャンセル
          </v-btn>
          <v-btn color="primary" v-on:click="sendSetAlarmCommand" :loading="isSendingSetAlarmCommand">
            実行
          </v-btn>
        </v-card-actions>
    </v-card>
  </v-dialog>

  <v-dialog persistent max-width="400" v-model="isShowDeleteAlarmConfirmDialog">
    <v-card>
      <v-card-text>
        選択したチャンネルのアラーム出力設定を解除します。よろしいですか？
      </v-card-text>
      <v-card-actions class="d-flex justify-end">
          <v-btn v-on:click="isShowDeleteAlarmConfirmDialog = false;" v-if="!isSendingDeleteAlarmCommand">
            キャンセル
          </v-btn>
          <v-btn color="error" v-on:click="sendDeleteAlarmCommand" :loading="isSendingDeleteAlarmCommand">
            実行
          </v-btn>
        </v-card-actions>
    </v-card>
  </v-dialog>

  <v-dialog persistent max-width="500" v-model="isShowCommandResponseErrorMessage">
    <v-card color="error">
      <v-card-item>
        <v-card-title>アラーム出力設定エラー</v-card-title>
      </v-card-item>
      <v-card-text>
        モジュールからの応答を確認できませんでした。モジュールの状態をご確認ください
      </v-card-text>
      <v-card-actions class="d-flex justify-end">
        <v-btn v-on:click="isShowCommandResponseErrorMessage = false;">
          閉じる
        </v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
import { defineComponent, ref, onMounted, watch, nextTick } from 'vue';

import axios from 'axios';

import { fromCognitoIdentityPool } from '@aws-sdk/credential-providers';
import { SignatureV4 } from '@smithy/signature-v4';
import { Sha256 } from '@aws-crypto/sha256-js';
import { HttpRequest } from '@smithy/protocol-http';

import mqtt from 'mqtt/dist/mqtt.min';

import config from '@/config.js';

export default defineComponent({
  name: 'AlarmOutputSetting',
  props: {
    moduleId: { type: String },
    isConfigurable: { type: Boolean }
  },

  setup(props) {

    const outputChannelKey = ref('');
    const outputChannels = ref([
      { title: '未選択', value: '' }
    ]);

    const isSendingGetAlarmCommand = ref(false);

    const isGetAlarmCommandSuccess = ref(null);
    const hasAlarmThresholds = ref(false);

    const inputChannelKey = ref('');
    const inputChannels = ref([
      { title: '未選択', value: '' }
    ]);

    const analogChannelsBasicInfo = {};

    const step1ConvertGain = ref(65535);

    const step2ConvertGain = ref(1);
    const step2ConvertOffset = ref(0);

    const step2ConvertDecimalDigits = ref(5);

    const inputUnit = ref('');

    const payload = ref({
      threshold: {}
    });

    const mainForm = ref();

    const disabledMinutes = ref('0');

    const isShowInputActionDialog = ref(false);

    const isShowThresholdEmptyMessage = ref(false);
    const isShowSetSuccessMessage = ref(false);

    const isShowDeleteSuccessMessage = ref(false);

    const dialogForm = ref();

    const thresholdType = ref('upper');

    const thresholdVal = ref('');
    const outputVal = ref('ON');
    const hasDuration = ref(false);
    const duration = ref('1');
    const durationUnit = ref('mSec');

    const isShowThresholdConflictMessage = ref(false);

    const isShowSetAlarmConfirmDialog = ref(false);
    const isSendingSetAlarmCommand = ref(false);

    const isShowDeleteAlarmConfirmDialog = ref(false);
    const isSendingDeleteAlarmCommand = ref(false);

    const isShowCommandResponseErrorMessage = ref(false);

    var credentials;

    var commandTimeoutID;
    var commandID;

    onMounted(async () => {

      credentials = await fromCognitoIdentityPool({
        clientConfig: { region: 'ap-northeast-1' },
        identityPoolId: config.COGNITO_IDENTITY_POOL_ID,
        logins: {
          ['cognito-idp.ap-northeast-1.amazonaws.com/' + config.COGNITO_USER_POOL_ID]: window.sessionStorage.getItem("access-token")
        }
      })().catch((/* error */) => {
        // TBD リフレッシュトークンの利用を検討
        window.sessionStorage.clear();
        window.sessionStorage.setItem('access-token-expired', 'true');

        window.location.reload();
      });

      if (!credentials) return;


      fetchChannelList();

      watch(outputChannelKey, () => {

        isGetAlarmCommandSuccess.value = null;
        hasAlarmThresholds.value = false;

        inputChannelKey.value = '';

        isShowDeleteSuccessMessage.value = false;

        if (outputChannelKey.value === '') {
          return;
        }

        sendGetAlarmCommand();

      });

      watch(inputChannelKey, () => {

        step1ConvertGain.value = 65535;

        step2ConvertGain.value = 1;
        step2ConvertOffset.value = 0;

        step2ConvertDecimalDigits.value = 5;

        inputUnit.value = '';

        if (!isSendingGetAlarmCommand.value) {
          payload.value = {
            threshold: {}
          };
        }

        isShowThresholdEmptyMessage.value = false;
        isShowSetSuccessMessage.value = false;

        if (inputChannelKey.value === '') {
          return;
        }


        if (inputChannelKey.value.startsWith('a')) {

          if (analogChannelsBasicInfo[inputChannelKey.value].mode === 'mA') {
            step1ConvertGain.value = 25;
          } else {
            step1ConvertGain.value = 10;
          }

          fetchConvertParams();

        }

      });

      watch(isShowInputActionDialog, () => {
        if (isShowInputActionDialog.value) {

          thresholdVal.value = '';

          if (inputChannelKey.value.startsWith('d')) {
            thresholdVal.value = (thresholdType.value === 'upper') ? '1' : '0';
          }

          outputVal.value = 'ON';
          hasDuration.value = false;
          duration.value = '1'
          durationUnit.value = 'mSec';

          isShowThresholdConflictMessage.value = false;
        }
      });

    });

    const getBrokerURL = async () => {

      const sigV4 = new SignatureV4({
        sha256: Sha256,

        region: 'ap-northeast-1',
        service: 'iotdevicegateway',
        credentials: {
          accessKeyId: credentials.accessKeyId,
          secretAccessKey: credentials.secretAccessKey
        }
      });

      const signedRequest = await sigV4.presign(new HttpRequest({
        method: 'GET',
        headers: {
          host: config.AWS_IOT_ENDPOINT
        },
        path: '/mqtt'
      }));

      signedRequest.query['X-Amz-Security-Token'] = credentials.sessionToken;

      const brokerURL = 'wss://' + config.AWS_IOT_ENDPOINT + signedRequest.path +
        '?' + new URLSearchParams(signedRequest.query).toString();

      return brokerURL;

    };

    const fetchChannelList = () => {
      axios.get(
        config.API_URL +
        `/modules/${ props.moduleId }/channels`,
        { headers: { Authorization: 'Bearer ' + window.sessionStorage.getItem('access-token') } }
      ).then((response) => {

        if ('do1' in response.data.channels) {
          outputChannels.value.push({
            title: '（デジタル出力1）' + response.data.channels.do1.name,
            value: 'do1'
          });
        }

        if ('do2' in response.data.channels) {
          outputChannels.value.push({
            title: '（デジタル出力2）' + response.data.channels.do2.name,
            value: 'do2'
          });
        }

        if ('a1' in response.data.channels) {
          inputChannels.value.push({
            title: '（アナログ1）' + response.data.channels.a1.name,
            value: 'a1'
          });

          analogChannelsBasicInfo.a1 = response.data.channels.a1;
        }

        if ('a2' in response.data.channels) {
          inputChannels.value.push({
            title: '（アナログ2）' + response.data.channels.a2.name,
            value: 'a2'
          });

          analogChannelsBasicInfo.a2 = response.data.channels.a2;
        }

        if ('a3' in response.data.channels) {
          inputChannels.value.push({
            title: '（アナログ3）' + response.data.channels.a3.name,
            value: 'a3'
          });

          analogChannelsBasicInfo.a3 = response.data.channels.a3;
        }

        if ('a4' in response.data.channels) {
          inputChannels.value.push({
            title: '（アナログ4）' + response.data.channels.a4.name,
            value: 'a4'
          });

          analogChannelsBasicInfo.a4 = response.data.channels.a4;
        }

        if ('d1' in response.data.channels) {
          inputChannels.value.push({
            title: '（デジタル入力1）' + response.data.channels.d1.name,
            value: 'd1'
          });
        }

        if ('d2' in response.data.channels) {
          inputChannels.value.push({
            title: '（デジタル入力2）' + response.data.channels.d2.name,
            value: 'd2'
          });
        }

      }).catch((/* error */) => {
        // TBD リフレッシュトークンの利用を検討
        window.sessionStorage.clear();
        window.sessionStorage.setItem('access-token-expired', 'true');

        window.location.reload();
      });
    };

    const fetchConvertParams = () => {
      axios.get(
        config.API_URL +
        `/modules/${ props.moduleId }/channels/analog/${ inputChannelKey.value.substring(1) }`,
        { headers: { Authorization: 'Bearer ' + window.sessionStorage.getItem('access-token') } }
      ).then((response) => {

        if (response.data.gain == null) {
          inputUnit.value = analogChannelsBasicInfo[inputChannelKey.value].mode;
        } else {

          step2ConvertGain.value = response.data.gain;
          step2ConvertOffset.value = response.data.offset;

          step2ConvertDecimalDigits.value = response.data.decimalDigits;

          inputUnit.value = analogChannelsBasicInfo[inputChannelKey.value].unit;

        }

      }).catch((/* error */) => {
        // TBD リフレッシュトークンの利用を検討
        window.sessionStorage.clear();
        window.sessionStorage.setItem('access-token-expired', 'true');

        window.location.reload();
      });
    };

    const sendGetAlarmCommand = async () => {

      isSendingGetAlarmCommand.value = true;

      const brokerURL = await getBrokerURL();
      const mqttClient = mqtt.connect(brokerURL, {
        reconnectPeriod: 0,
        clientId: props.moduleId + '_operator'
      });

      mqttClient.stream.on('close', () => {
        if (isSendingGetAlarmCommand.value) {
          isSendingGetAlarmCommand.value = false;
          isGetAlarmCommandSuccess.value = false;
        }
      });

      mqttClient.on('connect', () => {
        mqttClient.subscribe('status/' + props.moduleId + '/+', (error) => {
          if (error) return;

          commandTimeoutID = setTimeout(() => {
            isSendingGetAlarmCommand.value = false;
            isGetAlarmCommandSuccess.value = false;

            mqttClient.end();
          }, 10 * 1000);

          commandID = crypto.randomUUID().split('-')[0];

          mqttClient.publish(
            'command/' + props.moduleId,
            JSON.stringify({
              cmd: 'getAlarm',
              id: commandID,
              target: outputChannelKey.value
            })
          );

        });
      });

      mqttClient.on('message', (topic, message) => {
        if (topic.startsWith('status')) {
          const statusMessage = JSON.parse(message.toString());

          if (statusMessage.type === 'alarmSetting' && statusMessage.id === commandID) {
            clearTimeout(commandTimeoutID);

            if ('input' in statusMessage) {
              hasAlarmThresholds.value = true;

              inputChannelKey.value = statusMessage.input;
              payload.value.threshold = statusMessage.threshold;
              disabledMinutes.value = statusMessage.disabledMinutes.toString();
            }

            nextTick(() => {
              isSendingGetAlarmCommand.value = false;
              isGetAlarmCommandSuccess.value = true;
            });

            mqttClient.end();
          }
        }
      });

    };

    const convertToPhysicalValue = (rawValue) => {
      return Math.round(
        ((rawValue * step1ConvertGain.value / 65535) * step2ConvertGain.value + step2ConvertOffset.value) *
        (10 ** step2ConvertDecimalDigits.value)
      ) / (10 ** step2ConvertDecimalDigits.value);
    };

    const updatePayload = async () => {

      const { valid } = await dialogForm.value.validate();
      if (!valid) {
        return;
      }

      const action = {
        val: (outputVal.value === 'ON') ? 1 : 0
      };

      if (hasDuration.value) {
        action.duration = Number(duration.value);

        if (durationUnit.value === 'sec') {
          action.duration = action.duration * 10;
        }
      }

      if (thresholdType.value === 'recovered') {

        payload.value.threshold.recovered = {
          action: action
        };

      } else {

        let val = ((Number(thresholdVal.value) - step2ConvertOffset.value) / step2ConvertGain.value) * 65535 / step1ConvertGain.value;

        if (thresholdType.value === 'upper') {
          val = Math.floor(val);

          if (val < 1) {
            val = 1;
          }

          if (val > 65535) {
            val = 65535;
          }

        } else {
          val = Math.ceil(val);

          if (val < 0) {
            val = 0;
          }

          if (val > 65534) {
            val = 65534;
          }

        }

        const physicalVal = convertToPhysicalValue(val);

        if (thresholdType.value === 'upper') {

          while (val > 1) {
            if (convertToPhysicalValue(val - 1) === physicalVal) {
              val = val - 1;
            } else {
              break;
            }
          }

        } else {

          while (val < 65534) {
            if (convertToPhysicalValue(val + 1) === physicalVal) {
              val = val + 1;
            } else {
              break;
            }
          }

        }

        if ('upper' in payload.value.threshold) {

          for (let i = 0; i < payload.value.threshold.upper.length; i++) {

            if (payload.value.threshold.upper[i].val === val) {
              isShowThresholdConflictMessage.value = true;
              return;
            }

            if (convertToPhysicalValue(payload.value.threshold.upper[i].val) === physicalVal) {
              isShowThresholdConflictMessage.value = true;
              return;
            }

          }

        }

        if ('lower' in payload.value.threshold) {

          for (let i = 0; i < payload.value.threshold.lower.length; i++) {

            if (payload.value.threshold.lower[i].val === val) {
              isShowThresholdConflictMessage.value = true;
              return;
            }

            if (convertToPhysicalValue(payload.value.threshold.lower[i].val) === physicalVal) {
              isShowThresholdConflictMessage.value = true;
              return;
            }

          }

        }

        if (!(thresholdType.value in payload.value.threshold)) {
          payload.value.threshold[thresholdType.value] = [];
        }

        payload.value.threshold[thresholdType.value].push({
          val: val,
          action: action
        });

        payload.value.threshold[thresholdType.value].sort((a, b) => {
          return b.val - a.val;
        });

      }

      isShowInputActionDialog.value = false;

    };

    const deleteUpperThreshold = (index) => {

      payload.value.threshold.upper.splice(index, 1);

      if (payload.value.threshold.upper.length === 0) {
        delete payload.value.threshold.upper;
      }

      if (payload.value.threshold.upper == null && payload.value.threshold.lower == null) {
        delete payload.value.threshold.recovered;
      }

    };

    const deleteLowerThreshold = (index) => {

      payload.value.threshold.lower.splice(index, 1);

      if (payload.value.threshold.lower.length === 0) {
        delete payload.value.threshold.lower;
      }

      if (payload.value.threshold.lower == null && payload.value.threshold.upper == null) {
        delete payload.value.threshold.recovered;
      }

    };

    const showSetAlarmConfirmDialog = async () => {

      const { valid } = await mainForm.value.validate();
      if (!valid) {
        return;
      }

      isShowThresholdEmptyMessage.value = false;
      isShowSetSuccessMessage.value = false;

      if (payload.value.threshold.upper == null && payload.value.threshold.lower == null) {
        isShowThresholdEmptyMessage.value = true;
        return;
      }

      isShowSetAlarmConfirmDialog.value = true;

    };

    const sendSetAlarmCommand = async () => {

      isSendingSetAlarmCommand.value = true;

      commandID = crypto.randomUUID().split('-')[0];

      const threshold = structuredClone(payload.value.threshold);

      if ('upper' in threshold) {
        for (let i = 0; i < threshold.upper.length; i++) {
          threshold.upper[i].condition = threshold.upper.length - i;
        }
      }

      if ('lower' in threshold) {
        threshold.lower.sort((a, b) => {
          return a.val - b.val;
        });

        for (let i = 0; i < threshold.lower.length; i++) {
          threshold.lower[i].condition = i - threshold.lower.length;
        }
      }

      const brokerURL = await getBrokerURL();
      const mqttClient = mqtt.connect(brokerURL, {
        reconnectPeriod: 0,
        clientId: props.moduleId + '_operator'
      });

      mqttClient.on('connect', () => {
        mqttClient.subscribe('status/' + props.moduleId + '/+', (error) => {
          if (error) return;

          commandTimeoutID = setTimeout(() => {
            isShowSetAlarmConfirmDialog.value = false;
            isSendingSetAlarmCommand.value = false;

            outputChannelKey.value = '';

            isShowCommandResponseErrorMessage.value = true;

            mqttClient.end();
          }, 10 * 1000);

          mqttClient.publish(
            'command/' + props.moduleId,
            JSON.stringify({
              cmd: 'setAlarm',
              id: commandID,
              target: outputChannelKey.value,
              input: inputChannelKey.value,
              threshold: threshold,
              disabledMinutes: Number(disabledMinutes.value)
            })
          );

        });
      });

      mqttClient.on('message', (topic, message) => {
        if (topic.startsWith('status')) {
          const statusMessage = JSON.parse(message.toString());

          if (statusMessage.type === 'ackCommand' && statusMessage.id === commandID) {
            clearTimeout(commandTimeoutID);

            hasAlarmThresholds.value = true;

            isShowSetAlarmConfirmDialog.value = false;
            isSendingSetAlarmCommand.value = false;

            isShowSetSuccessMessage.value = true;

            mqttClient.end();
          }
        }
      });

    };

    const sendDeleteAlarmCommand = async () => {

      isSendingDeleteAlarmCommand.value = true;

      commandID = crypto.randomUUID().split('-')[0];

      const brokerURL = await getBrokerURL();
      const mqttClient = mqtt.connect(brokerURL, {
        reconnectPeriod: 0,
        clientId: props.moduleId + '_operator'
      });

      mqttClient.on('connect', () => {
        mqttClient.subscribe('status/' + props.moduleId + '/+', (error) => {
          if (error) return;

          commandTimeoutID = setTimeout(() => {
            isShowDeleteAlarmConfirmDialog.value = false;
            isSendingDeleteAlarmCommand.value = false;

            outputChannelKey.value = '';

            isShowCommandResponseErrorMessage.value = true;

            mqttClient.end();
          }, 10 * 1000);

          mqttClient.publish(
            'command/' + props.moduleId,
            JSON.stringify({
              cmd: 'deleteAlarm',
              id: commandID,
              target: outputChannelKey.value
            })
          );

        });
      });

      mqttClient.on('message', (topic, message) => {
        if (topic.startsWith('status')) {
          const statusMessage = JSON.parse(message.toString());

          if (statusMessage.type === 'ackCommand' && statusMessage.id === commandID) {
            clearTimeout(commandTimeoutID);

            isShowDeleteAlarmConfirmDialog.value = false;
            isSendingDeleteAlarmCommand.value = false;

            outputChannelKey.value = '';

            nextTick(() => {
              isShowDeleteSuccessMessage.value = true;
            });

            mqttClient.end();
          }
        }
      });

    };

    return {
      outputChannelKey,
      outputChannels,

      isSendingGetAlarmCommand,

      isGetAlarmCommandSuccess,
      hasAlarmThresholds,

      inputChannelKey,
      inputChannels,

      step1ConvertGain,

      step2ConvertGain,
      step2ConvertOffset,

      step2ConvertDecimalDigits,

      inputUnit,

      payload,

      mainForm,

      disabledMinutes,

      isShowInputActionDialog,

      isShowThresholdEmptyMessage,
      isShowSetSuccessMessage,

      isShowDeleteSuccessMessage,

      dialogForm,

      thresholdType,

      thresholdVal,
      outputVal,
      hasDuration,
      duration,
      durationUnit,

      isShowThresholdConflictMessage,

      isShowSetAlarmConfirmDialog,
      isSendingSetAlarmCommand,

      isShowDeleteAlarmConfirmDialog,
      isSendingDeleteAlarmCommand,

      isShowCommandResponseErrorMessage,

      convertToPhysicalValue,

      updatePayload,

      deleteUpperThreshold,
      deleteLowerThreshold,

      showSetAlarmConfirmDialog,
      sendSetAlarmCommand,

      sendDeleteAlarmCommand
    }

  }
});
</script>
